import { createComponent } from "@front/utils/alpine";
import { Alpine } from "alpinejs";

type TRangeSetupProps = {
    min: number,
    max: number,
    from: number,
    to: number,
    step?: number,
    unit?: string,
};

export default createComponent(() => ({
    min:  0,
    max:  0,
    from: 0,
    to:   0,
    step: 1,
    unit: '',
    withUrl: false,

    style () {
        return [
            'from', 'to', 'min', 'max', 'unit'
        ].map(prop =>
            `--${prop}: ${isNaN(this[prop]) ? `' ${this[prop]}'` : this[prop]}`
        ).join(';');
    },

    setup (this: Alpine, props: TRangeSetupProps) {
        Object.assign(this, props);

        const { from, to }: { from: HTMLInputElement, to: HTMLInputElement} = this.$refs

        from.addEventListener('input', (event) => {
            this.from = (event.target as HTMLInputElement).value;

            if(Number(this.from) > Number(to.value)) {
                this.to = this.from;
                this.from = to.value;
            }
        });
        from.addEventListener('change', () => this.$el.dispatchEvent(new Event('change')));

        to.addEventListener('input', (event) => {
            this.to = (event.target as HTMLInputElement).value;

            if(Number(this.to) < Number(from.value)) {
                this.from = this.to;
                this.to = from.value;
            }
        });
        to.addEventListener('change', () => this.$el.dispatchEvent(new Event('change')));

        if (this.withUrl) {
            const url = new URL(this.$el.dataset.searchUrl as string);
            const query = (url.searchParams.get('q') ?? '').split('/');

            this.$watch(['from', 'to'], () => {
                const rangeQuery = `price-${this.unit}-${this.from}-${this.to}`;

                const nextQuery = query?.filter(q => !q.match(/^price-/));
                nextQuery?.push(rangeQuery);

                url.searchParams.set('q', nextQuery.join('/'));
                this.$el.dataset.searchUrl = url.toString();
            });
        }
    },
}));
